import type {ReactElement} from 'react';
import {useState} from 'react';
import {isStockItemPredominantlyWhite} from '@Libraries/pmw-stock-media-library';
import {GridMediaItem} from '../grid-media-item';
import styles from './grid-icon-item.module.scss';
import type {GridIconItemProps} from '@Components/base-grid/components/grid-icon-item/grid-icon-item.types';

export function GridIconItem({...props}: GridIconItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasGrayBackground, setHasGrayBackground] = useState(false);
  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      hasGrayBackground={hasGrayBackground}
      thumb={
        <img
          onLoad={(): void => {
            setIsImageLoaded(true);
            void isStockItemPredominantlyWhite(props.thumbSrc).then(setHasGrayBackground);
          }}
          src={props.thumbSrc}
          className={styles.thumb}
          alt={window.i18next.t('pmwjs_image')}
          draggable="false"
          loading="lazy"
        />
      }
    />
  );
}
